import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import logologin from '../../../Comman/images/logo-new.png'
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';


class HeartRunnerHeaderComponent extends Component {
    constructor(props) {

        super(props);
        this.logout = this.logout.bind(this);
    }

    logout() {
        this.props.logout();
    }

    render() {
        return (
            <div>
                <nav className="user-menu">
                <a href="javascript:;" className="main-menu-access">
                    <i className="icon-proton-logo"></i>
                    <i className="icon-reorder"></i>
                </a>
            </nav>
            <section className="title-bar heaadd">
                <div className="logo">
                    <Link to="/superadmin/dashboard">
                        <img  src={logologin} alt="" />
                    </Link>
                </div>

              
                <div className="header-right">
                    <div className="profile_details_left">
                        <div className="header-right-left">
                            
                            
                            
                        </div>
                        <div className="profile_details">
                            <ul>
                                <li className="dropdown profile_details_drop">
                                    <a href="#" className="dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                                        <div className="profile_img">
                                            <span className="prfil-img"><i className="fa fa-user" aria-hidden="true"></i></span>
                                            <div className="clearfix"></div>
                                        </div>
                                    </a>
                                    <ul className="dropdown-menu drp-mnu">
                                        
                                        <li> 
                                            {/*<Link className="nav-link" to="/Admin/Profile"> 
                                                <i className="fa fa-user"></i>Profile
                                            </Link>*/}
                                        </li>
                                        <li> <a href="#" onClick={this.logout}><i className="fa fa-sign-out"></i> Logout</a> </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                        <div className="clearfix"> </div>
                    </div>
                </div>
                <div className="clearfix"> </div>
            </section>
            </div>
        );
    }
}

export default HeartRunnerHeaderComponent;